import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogContent,
} from '@angular/material/dialog';
import { DialogFooterComponent } from '../dialog-footer/dialog-footer.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { DialogExitComponent } from '../dialog-exit/dialog-exit.component';
import { IData } from 'src/app/interfaces/i-data.interface';
import { notesCharacterLimit } from 'src/app/constants/timesheetConstants';

@Component({
    selector: 'app-edit-note-dialog',
    templateUrl: './edit-note-dialog.component.html',
    styleUrls: ['./edit-note-dialog.component.scss'],
    imports: [
        DialogHeaderComponent,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        DialogFooterComponent,
        DialogExitComponent,
        MatInputModule,
    ],
})
export class EditNoteDialogComponent {
    formGroup: FormGroup;
    noteCounter: number;
    maxLength = notesCharacterLimit;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IData,
        private dialog: MatDialogRef<EditNoteDialogComponent>,
    ) {}

    ngOnInit(): void {
        this.formGroup = new FormGroup({}); // Creates new FormGroup
        Object.keys(this.data.formGroup.controls).forEach(
            (noteDayOfTheWeek) => {
                this.formGroup.addControl(
                    noteDayOfTheWeek,
                    new FormControl(
                        this.data.formGroup.controls[noteDayOfTheWeek].value,
                    ), // Makes a copy of the value
                );
            },
        );
        const noteMsg = this.formGroup.controls[this.data.day].value;
        this.noteCounter = noteMsg ? noteMsg.length : 0;
    }

    save(): void {
        this.data.formGroup.patchValue(this.formGroup.value); // Updates the values
        this.dialog.close(this.data.formGroup.value);
    }

    closeDialog(): void {
        this.dialog.close(); // Closes the dialog without saving
    }

    updateCharCount(text: string): void {
        this.noteCounter = text.length;
    }

    get cursorStyle(): string {
        if (this.data.readOnly) {
            return 'default';
        } else {
            return 'text';
        }
    }
}
